import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/footer/logo_eu.webp")